const socials = {
  instagram: { handle: 'jayouzcuisine', url: 'https://www.instagram.com/jayouzcuisine' },
  twitter: { handle: 'jayouzcuisine', url: 'https://twitter.com/jayouzcuisine' },
  tiktok: { handle: 'jayouz2025', url: 'https://www.tiktok.com/@jayouz2025' },
};

const contact = {
  email: 'sales.jayouz@gmail.com',
  phone: '+1 (585) 430-5330',
  phoneRaw: '15854305330',
};

const brandName = 'Jayouz Cuisine';

const orderProcessUrls = {
  returnUrl: 'https://jayouz.com',
  cancelUrl: 'https://jayouz.com',
};

const allowedStates = [
  { ab: 'NY', name: 'New York' },
  { ab: 'MA', name: 'Massachusetts' },
  { ab: 'FL', name: 'Florida' },
  { ab: 'IN', name: 'Indiana' },
  { ab: 'WA', name: 'Washington' },
  { ab: 'GA', name: 'Georgia' },
];

const config = { socials, contact, orderProcessUrls, brandName, allowedStates };

export default config;
